const print_for_base_color_variant = 39261927833655;
const print_for_base_color_variant_sku = 'print_for_base_color';

const print_with_my_logo_variant = 39261927866423;
const print_with_my_logo_variant_sku = 'print_with_my_logo_variant';

const range_on_this_theme_variant = 39261927899191;
const range_on_this_theme_sku = 'range_on_this_theme';

const customise_product_handle = "do-not-purchase-do-not-delete";

function getCartData() {
    window.$.getJSON('/cart.js')
        .done((cart) => {
            if (cart) {
                window.cartData = cart;                
                $('body').trigger('cart.items_refreshed')
            }
        })
}

/**
 *
 * @param {Number} variant_id - variant's customisation to be change
 */



// customisation rendering 


function generateCustomisationHtml(item) {

    var customisations;
    if (item.properties && item.properties._customisations) {
        customisations = item.properties._customisations;
    } else {
        return {};
    }

    console.log({asdasd: typeof customisations, v: item.variant_id, customisations});
    if (customisations && typeof customisations === "string") {
        customisations = JSON.parse(customisations);
    }
    var html_ = "";
    var baseColorPrice = 500;
    var logoPrice = 500;
    var themePrice = 6000;

    var text_arr = ["Customise this print for base color", "Customise this print with my logo","Customise range on this theme" ]
    for (var i in customisations) {
        var current_customisation = customisations[i];
        var baseColorQty = current_customisation._baseColorQty;
        var logoQty = current_customisation._logoQty;
        var themeQty = current_customisation._themeQty;     

        for ( var j in current_customisation){
            if(j == "_baseColorQty"){                
                html_ += `<div class="custom_request_block_wrapper">
                    <div class="request_item">
                    <div class="custom_icon"></div>
                    <div class="custom_info">${text_arr[0]}</div>
                    <div class="custom_request_qty">${baseColorQty}</div>
                        <div class="action_area">
                            <a href="https://pixemix.com/pages/custom-request?variants=${item.variant_id}&edit=yes"><div class="edit_icon"></div></a>
                        
                            <div class="trash delete_custom_request" title="Delete" data-variant="${item.variant_id}" data-request="0">
                                <span class="lid lift"></span>
                                <span class="can"></span>
                            </div>
                        </div>
                                        
                        <div class="price_block">
                            <span class="theme-money">
                                <span class="money conversion-bear-money" data-amount="${baseColorPrice * baseColorQty}">
                                Rs${baseColorPrice * baseColorQty}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>`
            }
            else if(j == "_logoQty"){
                html_ += `<div class="custom_request_block_wrapper">
                    <div class="request_item">
                    <div class="custom_icon"></div>
                    <div class="custom_info">${text_arr[1]}</div>
                    <div class="custom_request_qty">${logoQty}</div>
                        <div class="action_area">
                            <a href="https://pixemix.com/pages/custom-request?variants=${item.variant_id}&edit=yes">
                                <div class="edit_icon"></div>
                            </a>
                            
                            <div class="trash delete_custom_request" title="Delete" data-variant="${item.variant_id}" data-request="1">
                                <span class="lid lift"></span>
                                <span class="can"></span>
                            </div>
                    
                        </div>
                    
                        <div class="price_block">
                            <span class="theme-money">
                                <span class="money conversion-bear-money" data-amount="${logoPrice * logoQty}">
                                Rs${logoPrice * logoQty}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>`
            }
            else if(j == "_themeQty"){
                html_ += `<div class="custom_request_block_wrapper">
                    <div class="request_item">
                    <div class="custom_icon"></div>
                    <div class="custom_info">${text_arr[2]}</div>
                    <div class="custom_request_qty">${themeQty}</div>
                    <div class="action_area">
                        <div>                  
                            <a href="https://pixemix.com/pages/custom-request?variants=${item.variant_id}&edit=yes"><div class="edit_icon"></div></a>
                        </div>
                        
                        <div class="trash delete_custom_request" title="Delete" data-variant="${item.variant_id}" data-request="2">
                                <span class="lid lift"></span>
                                <span class="can"></span>
                        </div>
                                  
                    </div>
                  
                    <div class="price_block">
                        <span class="theme-money">
                            <span class="money conversion-bear-money" data-amount="${themePrice * themeQty}">
                            Rs${themePrice * themeQty}
                            </span>
                        </span>
                    </div>
                    </div>
                </div>`
            }

        }
        // console.log("customisations[i]--",customisations[i].length);        
    }

    return {
        html_    
    };

}

function addCustomisationHtml() {
    console.log("addCustomisationHtml:start");
    if (typeof cartData === "undefined") {
        return;
    }

    for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        if (item.properties && item.properties._customisations) {
            console.log("customisable");
            var html_;
            console.log("addCustomisationHtml--- item", item);
            var result = generateCustomisationHtml(item);
            html_ = result.html_;

            // console.log({html_, c: $('#customisations_' + item.variant_id).length, el: '#customisations_' + item.variant_id})
            $('#custom_request_block_' + item.variant_id).html(html_);

            // if(current_customisation_text) {
            //     configureCanvas(item.variant_id, current_customisation_text, current_customisation_text2, current_customisation_style)
            // }
        } else {
            console.log("not customisable");
        }
    }

   

    //removing customization from product
    $('.delete_custom_request').on('click', function() {
        // alert("delete_custom_request");
        var r = confirm("Are you sure you want to remove this custom request?");
        if (r == true) {
            txt = "You pressed OK!";
            console.log(txt);
            // console.log($(this).find('.cart-item'));
            var variant_id = $(this).data('variant'); 
            var request_no = $(this).data('request'); 
            // alert(variant_id);
            handleCustomisationDelete(variant_id, request_no);
        } else {
            txt = "You pressed Cancel!";
            console.log(txt);
        }
        // var index = $(this).parent().data('index');
       
        
    });

}

function deleteProperty(data, variant_id, variant_key){
    let sana = [];
    // let updatedProperty = {};
    let sanaObj ={}
    // var x = JSON.parse(data);
    // var x = typeof(String(data));
    // _customisations[0] = JSON.stringify(data);
        // for (let index = 0; index <= 0; index++) {
            sana.push(data);   
            // }
            
        console.log("sana", sana);
        for (let u = 0; u < sana.length; u++) {
            sanaObj[u.toString()] = sana[u];
        }
        //  = JSON.stringify(sana);
        console.log($.type(sana));
        var _customisations = {
            _customisations: JSON.stringify(sanaObj)
        }
        // var _customisations = {
        //     _customisations: ""
        // }
        console.log("_customisations----", _customisations);
    var updatedProperty = {
        id: variant_key,
        properties: _customisations
    }
    console.log("updatedProperty", updatedProperty);
    var propertyUpdateParams = {
        type: 'POST',
        url: '/cart/change.js',
        // dataType: 'json',
        // contentType: 'application/json',
        data: updatedProperty,
        // processData: false,
        success: function (line_item) {
            console.log("success updated property");
            // getCartData();
            window.location.href = "/cart";
                      
        },
        error: function (line_item) {
            console.log("error", line_item);
            console.log("fail delete property");
        },
        dataType: 'json'
    };
    $.ajax(propertyUpdateParams);
    
    let custom_properties = null;
    for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        if(item.variant_id == variant_id){
            custom_properties = item.properties._customisations[0];
        }
    }
    console.log("custom_properties", custom_properties);    
}

function deleteRequest(id, qty, updatedProperties, variant_id, variant_key){
    // console.log("type==", $.type(delete_property)); 
    // var request_data = JSON.stringify(delete_property);
    // console.log("request_data", request_data);
    // console.log("request_data -- type", $.type(request_data));
    // // var request = JSON.parse(request_data);
    // // console.log("request-- type", $.type(request));
    
    var data = {
        id: id,
        quantity: qty,
    }
    var params = {
        type: 'POST',
        url: '/cart/change.js',
        
        // contentType: 'application/json',
        data: data,
        // processData: false,
        success: function (line_item) {
            console.log("success");
            // getCartData();
            deleteProperty(updatedProperties, variant_id, variant_key);
            console.log("deleteProperty --- done");
        },
        error: function (line_item) {
            console.log("error", line_item);
            console.log("fail");
        },
        dataType: 'json'
    };
    $.ajax(params);
}

function removeCustomisation(itemToUpdate, allCustomisationProperty, variant_key) {
    var variant_key = variant_key;
    console.log("removeCustomisation");
    console.log({itemToUpdate})
    console.log("allCustomisationProperty-----", {allCustomisationProperty});
    var delete_request = itemToUpdate.properties._customisations[0];    // console.log("delete_request._themeQty", delete_request._themeQty);
    allCustomisationProperty = allCustomisationProperty[0][0];
    console.log("allCustomisationProperty array----", allCustomisationProperty);
    let tempAllProperties = [];
    tempAllProperties = allCustomisationProperty;
    let updatedProperties =[];
    // let updatedPropertiesObj = {};
    let baseColorQty = 0;
    let logoQty = 0;
    let themeQty = 0;

    for(p in allCustomisationProperty){
        console.log("p--", p);   
        // console.log("_baseColorQty", allCustomisationProperty._baseColorQty);  

        if(p == "_baseColorQty"){
            baseColorQty = allCustomisationProperty._baseColorQty
        }  
        else if(p == "_logoQty"){
            logoQty = allCustomisationProperty.logoQty
        }
        else if(p == "_themeQty"){
            themeQty = allCustomisationProperty.themeQty
        }
    }

    for(r in delete_request)
    {
        console.log("R--", r);
        if(r == "_baseColorQty"){ 
            // console.log("_baseColorQty");
            qty = delete_request._totatBaseColorQty - delete_request._baseColorQty;
            // tempAllProperties.pop({_baseColorQty: baseColorQty});
            delete tempAllProperties['_baseColorQty'];
            console.log("tempAllProperties", tempAllProperties);
            updatedProperties = tempAllProperties;                
            deleteRequest(delete_request.key, qty, updatedProperties, delete_request.variant_id, variant_key);
        }
        else if(r == "_logoQty"){
            // console.log("_logoQty");
            qty = delete_request._totatLogoQty - delete_request._logoQty;  
            delete tempAllProperties['_logoQty'];    
            updatedProperties = tempAllProperties;               
            deleteRequest(delete_request.key, qty, updatedProperties, delete_request.variant_id, variant_key);

        }
        else if(r == "_themeQty"){
            // console.log("_themeQty");
            qty = delete_request._totatThemeQty - delete_request._themeQty;
            delete tempAllProperties['_themeQty'];
            updatedProperties = tempAllProperties;                        
            deleteRequest(delete_request.key, qty, updatedProperties, delete_request.variant_id, variant_key)
        }
        
    }
    // if (delete_request._baseColorQty != 0) {
    //     
    // }
    // else if (delete_request._logoQty != 0) {
    //     console.log("_logoQty");
    // }
    // else if (delet_request._themeQty !== "undefined") {
    //     console.log("_themeQty");
    // }
    

    // $.ajax(params);
}

function handleCustomisationDelete(variant_id, custom_request) {

    console.log("handleCustomisationDelete",variant_id);
    console.log("cartData---", cartData); 
    let updatedCustomisation = [];
    let updatedCustomisationObj = {};
    let itemToUpdate = {};
    let totalBaseColorQty = 0;
    let totalLogoQty = 0; 
    let totalThemeQty = 0;
    let delete_request = {};
    let allCustomisation = [];
    let allCustomisationObj = {};
    let allCustomisationProperty = {};
    let variant_key = null;
    let baseColorKey = null;
    let logoKey = null;
    let themeKey = null;

    for (var i = 0; i < cartData.items.length; i++) {
        var item = cartData.items[i];
        if(item.variant_id == print_for_base_color_variant){
            totalBaseColorQty = item.quantity;
            baseColorKey = item.key;
        }
        if(item.variant_id == print_with_my_logo_variant){
            totalLogoQty = item.quantity;
            logoKey = item.key;
        }
        if(item.variant_id == range_on_this_theme_variant){
            totalThemeQty = item.quantity;
            themeKey = item.key;
        }
        // console.log("item----handleCustomisationDelete---",item);
        if (item.variant_id === variant_id) {
            variant_key = item.key;
            // console.log("item.variant_id === variant_id---",item.variant_id);
            if (item.properties && item.properties._customisations && typeof item.properties._customisations === "string") {
                // if (item.properties && item.properties._customisations) {
                    // console.log("Object.keys(item.properties._customisations).length", Object.keys(item.properties._customisations).length);
                // console.log("item.properties---", item.properties);
                item.properties._customisations = JSON.parse(item.properties._customisations);
                console.log("item.properties._customisations after parse ----", item.properties._customisations);
                allCustomisation.push(item.properties._customisations);
                console.log("AllCustomisation--", allCustomisation);
            }
            if (item.properties && item.properties._customisations && Object.keys(item.properties._customisations).length) {
                customisations = item.properties._customisations;

                for (var p in customisations) {

                    var current_customisation = customisations[p];
                    var baseColorQty = current_customisation._baseColorQty;
                    var logoQty = current_customisation._logoQty;
                    var themeQty = current_customisation._themeQty;

                    
                    for ( var q in current_customisation){
                        // console.log("idx j--", q);
                        
                        var qty_value = item.properties._customisations[p][q]
                        if(q == "_baseColorQty" && custom_request == 0){
                            // console.log("updatedCustomisation _baseColorQty");
                            // console.log("item.properties._customisations[i][j]", item.properties._customisations[p][q]);                            
                            updatedCustomisation.push({key: baseColorKey, variant_id: item.variant_id, _baseColorQty: qty_value, _totatBaseColorQty: totalBaseColorQty});
                            // console.log("current_customisation", current_customisation);
                           
                            
                        }
                        else if(q == "_logoQty" && custom_request == 1){
                            // console.log("updatedCustomisation _logoQty");
                            // updatedCustomisation.push(item.properties._customisations["_logoQty"]);
                            updatedCustomisation.push({key: logoKey, variant_id: item.variant_id, _logoQty: qty_value, _totatLogoQty: totalLogoQty});
                        }
                        else if(q == "_themeQty" && custom_request == 2){
                            // console.log("updatedCustomisation _themeQty");
                            // updatedCustomisation.push(item.properties._customisations["_themeQty"]);
                            updatedCustomisation.push({key: themeKey, variant_id: item.variant_id, _themeQty: qty_value, _totatThemeQty: totalThemeQty});

                        }
                    }                    
                }
                // console.log("updatedCustomisation----", updatedCustomisation);
                itemToUpdate = {
                    // line: i + 1,
                    // quantity: item.quantity,
                    properties: item.properties
                };
            
                if (updatedCustomisation.length) {
                    // updatedCustomisation = JSON.parse(updatedCustomisation);
                    for (let u = 0; u < updatedCustomisation.length; u++) {
                        updatedCustomisationObj[u.toString()] = updatedCustomisation[u];
                    }
                }
                if (allCustomisation.length) {
                    // updatedCustomisation = JSON.parse(updatedCustomisation);
                    // for (let u = 0; u < allCustomisation.length; u++) {
                    allCustomisationObj = allCustomisation;
                    
                }
                if ( Object.keys(allCustomisationObj).length) {
                    allCustomisationProperty = allCustomisationObj;
                } else {
                    allCustomisationProperty = null;
                }
                
                // console.log("updatedCustomisationObj--",{
                //     updatedCustomisationObj
                // })
                if ( Object.keys(updatedCustomisationObj).length) {
                    itemToUpdate.properties._customisations = updatedCustomisationObj;
                } else {
                    itemToUpdate.properties._customisations = null;
                }
            }
        }
    }
    // console.log("handleCustomisationDelete", itemToUpdate);
    if (itemToUpdate && Object.keys(itemToUpdate).length) {
        removeCustomisation(itemToUpdate, allCustomisationProperty, variant_key)
    }
}

$(document).ready(function () {

    getCartData();

    $('body').on('cart.items_refreshed', function () {

        // show customisation block
        addCustomisationHtml();

        // var updates = checkCartForCustomisedProducts(window.cartData);

        // if (updates && Object.keys(updates).length) {
        //     callCartUpdates(updates);
        // }
    });

  //removing customization from product
    

    // //remove button set qty to 0
    // $(".cart__remove-btn").on('click', function () {
    //     var variant_id = $(this).closest('.cart__item').data("variant-id");
    //     var quantity = 0;

    //     var updates = anaylseCartData(cartData, variant_id, quantity);
    //     callCartUpdates(updates, variant_id, true);
    // });

  
  
  

});